import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { BzObjType } from '../Enums/BzObjType.enum';
import { EMode } from '../Enums/EMode.enum';
import { SdObjType } from '../Enums/SdObjType.enum';

export class PositionDetails<T extends EMode = EMode.entity> {
  /** Alias: pos_Code */
  pos_Code?: number;
  /** Alias: pos_BzObjType */
  pos_BzObjType?: BzObjType;
  /** Alias: pos_BzObjMemberCode */
  pos_BzObjMemberCode?: number;
  /** Alias: bz_SdObjMemberCode */
  bz_SdObjMemberCode?: number;
  /** Alias: bz_SdObjType */
  bz_SdObjType?: SdObjType;
  /** Alias: bz_ProjektCode */
  bz_ProjektCode?: number;
  /** Alias: bz_Date */
  bz_Date?: string;
  /** Alias: bz_NetValue */
  bz_NetValue?: number;
  /** Alias: bz_NetValueCurrency */
  bz_NetValueCurrency?: number;
  /** Alias: bz_BranchName */
  bz_BranchName?: string;
  /** Alias: bz_Number */
  bz_Number?: number;
  /** Alias: bz_Sign */
  bz_Sign?: string;
  /** Alias: bz_EInvoiceBT14 */
  bz_EInvoiceBT14?: string;
  /** Alias: bz_EInvoiceBT18 */
  bz_EInvoiceBT18?: string;
  /** Alias: bz_EInvoiceBT13 */
  bz_EInvoiceBT13?: string;
  /** Alias: bz_EInvoiceBT15 */
  bz_EInvoiceBT15?: string;
  /** Alias: bz_EInvoiceBT11 */
  bz_EInvoiceBT11?: string;
  /** Alias: bz_EInvoiceReverseCharge */
  bz_EInvoiceReverseCharge?: boolean;
  /** Alias: bz_EInvoiceBT17 */
  bz_EInvoiceBT17?: string;
  /** Alias: bz_EInvoiceBT16 */
  bz_EInvoiceBT16?: string;
  /** Alias: bz_EInvoiceBT12 */
  bz_EInvoiceBT12?: string;
  /** Alias: bz_ContactPersonName */
  bz_ContactPersonName?: string;
  /** Alias: bz_Company_GroupName */
  bz_Company_GroupName?: string;
  /** Alias: bz_Company_GroupIdentification */
  bz_Company_GroupIdentification?: string;
  /** Alias: bz_DeliveryAddrContactPersonName */
  bz_DeliveryAddrContactPersonName?: string;
  /** Alias: bz_DeliveryAddrCountry */
  bz_DeliveryAddrCountry?: string;
  /** Alias: bz_DeliveryAddrText */
  bz_DeliveryAddrText?: string;
  /** Alias: bz_BillAddrCompany */
  bz_BillAddrCompany?: string;
  /** Alias: bz_BillAddrContactPersonName */
  bz_BillAddrContactPersonName?: string;
  /** Alias: bz_BillAddrCountry */
  bz_BillAddrCountry?: string;
  /** Alias: bz_Company_Language */
  bz_Company_Language?: string;
  /** Alias: pos_Article_GroupName */
  pos_Article_GroupName?: string;
  /** Alias: pos_Article_Number */
  pos_Article_Number?: string;
  /** Alias: pos_GrossProfit */
  pos_GrossProfit?: number;
  /** Alias: pos_Surcharge */
  pos_Surcharge?: number;
  /** Alias: pos_DbPerCent */
  pos_DbPerCent?: number;
  /** Alias: pos_AmountOrdered */
  pos_AmountOrdered?: number;
  /** Alias: pos_DispositionStart */
  pos_DispositionStart?: string;
  /** Alias: pos_DispositionStartWeek */
  pos_DispositionStartWeek?: number;
  /** Alias: pos_PlanedDeliveryDateCalenderWeek */
  pos_PlanedDeliveryDateCalenderWeek?: number;
  /** Alias: pos_TotalWeight */
  pos_TotalWeight?: number;
  /** Alias: pos_IsInternal */
  pos_IsInternal?: boolean;
  /** Alias: pos_AmountDelivered */
  pos_AmountDelivered?: number;
  /** Alias: pos_Article_ParentGroup */
  pos_Article_ParentGroup?: string;
  /** Alias: bz_Project_Name */
  bz_Project_Name?: string;
  /** Alias: bz_Project_Number */
  bz_Project_Number?: string;
  /** Alias: bz_ParentProject_Name */
  bz_ParentProject_Name?: string;
  /** Alias: bz_ParentProject_Number */
  bz_ParentProject_Number?: string;
  /** Alias: bz_HallName */
  bz_HallName?: string;
  /** Alias: bz_Currency */
  bz_Currency?: string;
  /** Alias: bz_Status1 */
  bz_Status1?: boolean;
  /** Alias: bz_Status2 */
  bz_Status2?: boolean;
  /** Alias: bz_Status3 */
  bz_Status3?: boolean;
  /** Alias: bz_Status4 */
  bz_Status4?: boolean;
  /** Alias: bz_Status5 */
  bz_Status5?: boolean;
  /** Alias: bz_DispoFrom */
  bz_DispoFrom?: string;
  /** Alias: bz_DispoFromWeek */
  bz_DispoFromWeek?: number;
  /** Alias: bz_DispoTo */
  bz_DispoTo?: string;
  /** Alias: bz_DispoToWeek */
  bz_DispoToWeek?: number;
  /** Alias: bz_ActualDeliveryDate */
  bz_ActualDeliveryDate?: string;
  /** Alias: bz_ActualDeliveryDateWeek */
  bz_ActualDeliveryDateWeek?: number;
  /** Alias: bz_OutgoingDeliveryDate */
  bz_OutgoingDeliveryDate?: string;
  /** Alias: bz_OutgoingDeliveryDateWeek */
  bz_OutgoingDeliveryDateWeek?: number;
  /** Alias: bz_Project_FromDate */
  bz_Project_FromDate?: string;
  /** Alias: bz_Project_FromDateWeek */
  bz_Project_FromDateWeek?: number;
  /** Alias: bz_Project_ToDate */
  bz_Project_ToDate?: string;
  /** Alias: bz_Project_ToDateWeek */
  bz_Project_ToDateWeek?: number;
  /** Alias: bz_TourName */
  bz_TourName?: string;
  /** Alias: bz_TourMo */
  bz_TourMo?: boolean;
  /** Alias: bz_TourDi */
  bz_TourDi?: boolean;
  /** Alias: bz_TourMi */
  bz_TourMi?: boolean;
  /** Alias: bz_TourDo */
  bz_TourDo?: boolean;
  /** Alias: bz_TourFr */
  bz_TourFr?: boolean;
  /** Alias: bz_TourSa */
  bz_TourSa?: boolean;
  /** Alias: bz_DeliveryAddr_Name */
  bz_DeliveryAddr_Name?: string;
  /** Alias: bz_Company_Country */
  bz_Company_Country?: string;
  /** Alias: bz_Company_Name */
  bz_Company_Name?: string;
  /** Alias: bz_Company_Number */
  bz_Company_Number?: number;
  /** Alias: bz_CostCenter */
  bz_CostCenter?: string;
  /** Alias: bz_GrossTotal */
  bz_GrossTotal?: number;
  /** Alias: bz_GrossTotalCurrency */
  bz_GrossTotalCurrency?: number;
  /** Alias: bz_Note */
  bz_Note?: string;
  /** Alias: bz_ExchangeRate */
  bz_ExchangeRate?: number;
  /** Alias: pos_TrackedTime */
  pos_TrackedTime?: number;
  /** Alias: pos_AmountBilled */
  pos_AmountBilled?: number;
  /** Alias: pos_Article_InventoryAmount */
  pos_Article_InventoryAmount?: number;
  /** Alias: pos_Article_DefaultStorage */
  pos_Article_DefaultStorage?: string;
  /** Alias: bz_ApprovedInShop */
  bz_ApprovedInShop?: boolean;
  /** Alias: bz_Total_AufPerCent */
  bz_Total_AufPerCent?: number;
  /** Alias: bz_Total_DbPerCent */
  bz_Total_DbPerCent?: number;
  /** Alias: bz_TotalPurchaseValue */
  bz_TotalPurchaseValue?: number;
  /** Alias: bz_TotalGrossProfit */
  bz_TotalGrossProfit?: number;
  /** Alias: bz_TypeOfPayment */
  bz_TypeOfPayment?: string;
  /** Alias: bz_TotalTrackedTime */
  bz_TotalTrackedTime?: number;
  /** Alias: sum_AmountIncomingDeliveryNote */
  sum_AmountIncomingDeliveryNote?: number;
  /** Alias: pos_RealBzObjType */
  pos_RealBzObjType?: BzObjType;
  /** Alias: bz_UserResponsible */
  bz_UserResponsible?: string;
  /** Alias: bz_UserResponsible_Code */
  bz_UserResponsible_Code?: number;

  __typename?: string;
}

const fields: FieldDefinitions<PositionDetails> = {
  pos_Code: {
    alias: 'pos_Code',
  },
  pos_BzObjType: {
    alias: 'pos_BzObjType',
  },
  pos_BzObjMemberCode: {
    alias: 'pos_BzObjMemberCode',
  },
  bz_SdObjMemberCode: {
    alias: 'bz_SdObjMemberCode',
  },
  bz_SdObjType: {
    alias: 'bz_SdObjType',
  },
  bz_ProjektCode: {
    alias: 'bz_ProjektCode',
  },
  bz_Date: {
    alias: 'bz_Date',
  },
  bz_NetValue: {
    alias: 'bz_NetValue',
  },
  bz_NetValueCurrency: {
    alias: 'bz_NetValueCurrency',
  },
  bz_BranchName: {
    alias: 'bz_BranchName',
  },
  bz_Number: {
    alias: 'bz_Number',
  },
  bz_Sign: {
    alias: 'bz_Sign',
  },
  bz_EInvoiceBT14: {
    alias: 'bz_EInvoiceBT14',
  },
  bz_EInvoiceBT18: {
    alias: 'bz_EInvoiceBT18',
  },
  bz_EInvoiceBT13: {
    alias: 'bz_EInvoiceBT13',
  },
  bz_EInvoiceBT15: {
    alias: 'bz_EInvoiceBT15',
  },
  bz_EInvoiceBT11: {
    alias: 'bz_EInvoiceBT11',
  },
  bz_EInvoiceReverseCharge: {
    alias: 'bz_EInvoiceReverseCharge',
  },
  bz_EInvoiceBT17: {
    alias: 'bz_EInvoiceBT17',
  },
  bz_EInvoiceBT16: {
    alias: 'bz_EInvoiceBT16',
  },
  bz_EInvoiceBT12: {
    alias: 'bz_EInvoiceBT12',
  },
  bz_ContactPersonName: {
    alias: 'bz_ContactPersonName',
  },
  bz_Company_GroupName: {
    alias: 'bz_Company_GroupName',
  },
  bz_Company_GroupIdentification: {
    alias: 'bz_Company_GroupIdentification',
  },
  bz_DeliveryAddrContactPersonName: {
    alias: 'bz_DeliveryAddrContactPersonName',
  },
  bz_DeliveryAddrCountry: {
    alias: 'bz_DeliveryAddrCountry',
  },
  bz_DeliveryAddrText: {
    alias: 'bz_DeliveryAddrText',
  },
  bz_BillAddrCompany: {
    alias: 'bz_BillAddrCompany',
  },
  bz_BillAddrContactPersonName: {
    alias: 'bz_BillAddrContactPersonName',
  },
  bz_BillAddrCountry: {
    alias: 'bz_BillAddrCountry',
  },
  bz_Company_Language: {
    alias: 'bz_Company_Language',
  },
  pos_Article_GroupName: {
    alias: 'pos_Article_GroupName',
  },
  pos_Article_Number: {
    alias: 'pos_Article_Number',
  },
  pos_GrossProfit: {
    alias: 'pos_GrossProfit',
  },
  pos_Surcharge: {
    alias: 'pos_Surcharge',
  },
  pos_DbPerCent: {
    alias: 'pos_DbPerCent',
  },
  pos_AmountOrdered: {
    alias: 'pos_AmountOrdered',
  },
  pos_DispositionStart: {
    alias: 'pos_DispositionStart',
  },
  pos_DispositionStartWeek: {
    alias: 'pos_DispositionStartWeek',
  },
  pos_PlanedDeliveryDateCalenderWeek: {
    alias: 'pos_PlanedDeliveryDateCalenderWeek',
  },
  pos_TotalWeight: {
    alias: 'pos_TotalWeight',
  },
  pos_IsInternal: {
    alias: 'pos_IsInternal',
  },
  pos_AmountDelivered: {
    alias: 'pos_AmountDelivered',
  },
  pos_Article_ParentGroup: {
    alias: 'pos_Article_ParentGroup',
  },
  bz_Project_Name: {
    alias: 'bz_Project_Name',
  },
  bz_Project_Number: {
    alias: 'bz_Project_Number',
  },
  bz_ParentProject_Name: {
    alias: 'bz_ParentProject_Name',
  },
  bz_ParentProject_Number: {
    alias: 'bz_ParentProject_Number',
  },
  bz_HallName: {
    alias: 'bz_HallName',
  },
  bz_Currency: {
    alias: 'bz_Currency',
  },
  bz_Status1: {
    alias: 'bz_Status1',
  },
  bz_Status2: {
    alias: 'bz_Status2',
  },
  bz_Status3: {
    alias: 'bz_Status3',
  },
  bz_Status4: {
    alias: 'bz_Status4',
  },
  bz_Status5: {
    alias: 'bz_Status5',
  },
  bz_DispoFrom: {
    alias: 'bz_DispoFrom',
  },
  bz_DispoFromWeek: {
    alias: 'bz_DispoFromWeek',
  },
  bz_DispoTo: {
    alias: 'bz_DispoTo',
  },
  bz_DispoToWeek: {
    alias: 'bz_DispoToWeek',
  },
  bz_ActualDeliveryDate: {
    alias: 'bz_ActualDeliveryDate',
  },
  bz_ActualDeliveryDateWeek: {
    alias: 'bz_ActualDeliveryDateWeek',
  },
  bz_OutgoingDeliveryDate: {
    alias: 'bz_OutgoingDeliveryDate',
  },
  bz_OutgoingDeliveryDateWeek: {
    alias: 'bz_OutgoingDeliveryDateWeek',
  },
  bz_Project_FromDate: {
    alias: 'bz_Project_FromDate',
  },
  bz_Project_FromDateWeek: {
    alias: 'bz_Project_FromDateWeek',
  },
  bz_Project_ToDate: {
    alias: 'bz_Project_ToDate',
  },
  bz_Project_ToDateWeek: {
    alias: 'bz_Project_ToDateWeek',
  },
  bz_TourName: {
    alias: 'bz_TourName',
  },
  bz_TourMo: {
    alias: 'bz_TourMo',
  },
  bz_TourDi: {
    alias: 'bz_TourDi',
  },
  bz_TourMi: {
    alias: 'bz_TourMi',
  },
  bz_TourDo: {
    alias: 'bz_TourDo',
  },
  bz_TourFr: {
    alias: 'bz_TourFr',
  },
  bz_TourSa: {
    alias: 'bz_TourSa',
  },
  bz_DeliveryAddr_Name: {
    alias: 'bz_DeliveryAddr_Name',
  },
  bz_Company_Country: {
    alias: 'bz_Company_Country',
  },
  bz_Company_Name: {
    alias: 'bz_Company_Name',
  },
  bz_Company_Number: {
    alias: 'bz_Company_Number',
  },
  bz_CostCenter: {
    alias: 'bz_CostCenter',
  },
  bz_GrossTotal: {
    alias: 'bz_GrossTotal',
  },
  bz_GrossTotalCurrency: {
    alias: 'bz_GrossTotalCurrency',
  },
  bz_Note: {
    alias: 'bz_Note',
  },
  bz_ExchangeRate: {
    alias: 'bz_ExchangeRate',
  },
  pos_TrackedTime: {
    alias: 'pos_TrackedTime',
  },
  pos_AmountBilled: {
    alias: 'pos_AmountBilled',
  },
  pos_Article_InventoryAmount: {
    alias: 'pos_Article_InventoryAmount',
  },
  pos_Article_DefaultStorage: {
    alias: 'pos_Article_DefaultStorage',
  },
  bz_ApprovedInShop: {
    alias: 'bz_ApprovedInShop',
  },
  bz_Total_AufPerCent: {
    alias: 'bz_Total_AufPerCent',
  },
  bz_Total_DbPerCent: {
    alias: 'bz_Total_DbPerCent',
  },
  bz_TotalPurchaseValue: {
    alias: 'bz_TotalPurchaseValue',
  },
  bz_TotalGrossProfit: {
    alias: 'bz_TotalGrossProfit',
  },
  bz_TypeOfPayment: {
    alias: 'bz_TypeOfPayment',
  },
  bz_TotalTrackedTime: {
    alias: 'bz_TotalTrackedTime',
  },
  sum_AmountIncomingDeliveryNote: {
    alias: 'sum_AmountIncomingDeliveryNote',
  },
  pos_RealBzObjType: {
    alias: 'pos_RealBzObjType',
  },
  bz_UserResponsible: {
    alias: 'bz_UserResponsible',
  },
  bz_UserResponsible_Code: {
    alias: 'bz_UserResponsible_Code',
  },
  __typename: {
    alias: '__typename',
  },
};

export const positionDetailsEntityDefinition: EntitiyDefinition<PositionDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'PositionDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
